import { getUserFullName } from '../../../../utils/user'
import { REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES } from '../../../Request'

// The modal builds the mass-action shape (`assignees: [ids]`); the profile
// PATCH nests the ids and the optional notification comment under `assignees`.
export function getBirdviewAssignPayload({
  [REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]: assignees,
  ...rest
}) {
  return {
    [REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]: {
      ...rest,
      user_ids: assignees,
    },
  }
}

export function getBirdviewAssigneeName(values) {
  const [user] = values[REQUEST_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]

  return user ? getUserFullName(user) : null
}
